import React from 'react';
import { TaskManagerContextProvider } from '../TaskManagerContext';
import ClientTasksManager from './ClientTasksManager';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';
import { parse, stringify } from 'query-string';

const ClientTasksApp = ({ clientId }: { clientId: string }) => (
  <QueryParamProvider
    adapter={ReactRouter5Adapter}
    options={{
      objectToSearchString: stringify,
      searchStringToObject: parse,
      removeDefaultsFromUrl: false,
    }}
  >
    <TaskManagerContextProvider>
      <ClientTasksManager clientId={clientId} />
    </TaskManagerContextProvider>
  </QueryParamProvider>
);

export default ClientTasksApp;
